module.exports = __webpack_public_path__ + "media/images/common/icon_placeholeder-a73efdbda376e493c5a6969560b37fab.png";